module.exports = __webpack_public_path__ + "img/card.bdef9b63.svg";